import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SubmissionSuccess = (props) => {
    const routerNavigate = useNavigate();
    const navigate = props.navigate || routerNavigate;
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (countdown <= 0 && props.onComplete) {
            props.onComplete();
        }
    }, [countdown, props.onComplete]);

    return (
        <div className="min-h-[100dvh] bg-white flex flex-col font-sans">
            {/* Animation Content */}
            <div className="flex-1 flex flex-col items-center justify-center px-6">
                <h1 className="text-2xl font-bold text-gray-900 text-center mb-12">
                    Thank You, Mission's Saved
                </h1>

                {/* Circular Countdown Animation */}
                <div className="relative w-32 h-32 flex items-center justify-center mb-6">
                    <div className="absolute inset-0 border-[6px] border-black rounded-full"></div>
                    <span className="text-4xl font-bold text-gray-900">
                        {countdown}
                    </span>
                </div>

                <p className="text-gray-400 font-medium animate-pulse">
                    Returning to home...
                </p>
            </div>

            {/* Simple Bottom Navigation Placeholder for consistency */}
            <nav className="bg-white border-t border-gray-100">
                <div className="flex items-center justify-center gap-x-20 py-4 max-w-md mx-auto opacity-50">
                    <button className="flex flex-col items-center space-y-1 text-teal-600">
                        <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                        <span className="text-[11px] font-medium">Home</span>
                    </button>
                    <button className="flex flex-col items-center space-y-1 text-gray-400">
                        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-[11px] font-medium">Logs</span>
                    </button>
                </div>
            </nav>
        </div>
    );
};

export default SubmissionSuccess;
